import { lazy } from 'react';

import { useRouteMatch } from 'react-router'

import { SPENDING_CARD_MANAGEMENT_URL } from '@webapp/app/routers/SpendingCardRouter/constants/urls'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { type PayCard } from '@webapp/models'
import { PayCardStatuses } from '@webapp/models/enums'
import messages from './messages'

export interface SpendingCardManagementDetailsPageParams {
  card: PayCard['external_id']
}

const SpendingCardManagementDetailsViewChunk = lazy(() =>
  import('../containers/SpendingCardManagementDetailsView').then(
    ({ SpendingCardManagementDetailsView }) => ({
      default: SpendingCardManagementDetailsView,
    })
  )
)

export const SpendingCardManagementDetailsPage = () => {
  const intl = useProcurifyIntl()
  const match = useRouteMatch()
  const { url } = useAppRoutes()

  const shouldRedirectToAwxRoutes = match.path.includes('manage-cards')

  return (
    <Page
      pageTitle={intl.formatMessage(messages.spendingCardManagementTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.spendingCardManagementTitle),
          link: shouldRedirectToAwxRoutes
            ? url('CardManagementPage', {
                status: PayCardStatuses.ACTIVE,
              })
            : `${SPENDING_CARD_MANAGEMENT_URL}/${PayCardStatuses.ACTIVE}`,
        },
        {
          name: intl.formatMessage(
            messages.spendingCardManagementDetailsPageTitle
          ),
        },
      ]}
    >
      <SpendingCardManagementDetailsViewChunk />
    </Page>
  )
}
